import { Modal } from 'react-bootstrap'
import '../styles/CustomModal.css'
import { closeIcon } from '../utils/svgs'

const CustomModal = ({ show, handleClose, children, size = 'lg', heading = "Import", customHeaderCss = '' }) => {
    return (
        <Modal show={show} centered size={size}>
            <Modal.Body>
                <div className={`custom_modal_header ${customHeaderCss}`}>
                    <h4>{heading}</h4>
                    <button onClick={handleClose}>{closeIcon}</button>
                </div>

                {children}
            </Modal.Body>
        </Modal>
    )
}

export default CustomModal